import axios from 'axios';

const getById = async (memberId) => {
  try {
    const {
      data: { Member },
    } = await axios.get(`/api/members?memberId=${memberId}`);
    return Member;
  } catch (e) {
    console.error(e);
    throw new Error(e);
  }
};

const getUserData = async () => {
  try {
    const { data } = await axios.get('/profile');
    return data;
  } catch (e) {
    console.error(e);
  }
};

const validateAdminAccess = async (email) => {
  const {
    data: { isAdmin },
  } = await axios.get(`/api/isUserAdmin?email=${email}`);
  return isAdmin;
};

export const MembersService = {
  getById,
  getUserData,
  validateAdminAccess,
};
